module.exports = __webpack_public_path__ + "img/corchete-header-02.a05393a8.webp";